import type * as React from 'react';
import { getPaginated } from '@Domain/Api';
import documentTemplateVersionsFetched, {
	type DocumentTemplateVersionPayload,
	type DocumentTemplateVersionsFetchedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateVersionsFetched';
import documentTemplateVersionsFetchFailed, {
	type DocumentTemplateVersionsFetchFailedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateVersionsFetchFailed';
import type FetchDocumentTemplateVersions from '@Application/Documents/Templates/Queries/FetchDocumentTemplateVersions';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTemplateVersionsFetchedAction | DocumentTemplateVersionsFetchFailedAction;

type PaginatedDocumentTemplateVersions = {
	totalRecords: number;
	results: DocumentTemplateVersionPayload[];
};

export default (query: FetchDocumentTemplateVersions) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// No server filter: the front reads every version of the organization in one go.
			const response = await getPaginated<PaginatedDocumentTemplateVersions>(
				`${parameters.api.host}/api/organizations/${query.organizationId}/document-template-versions`,
				{ page: 0, rowsPerPage: 200 },
			);

			const action = documentTemplateVersionsFetched(response.results, query.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTemplateVersionsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
